var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs 1",
    clipPath: "url(#clip0_62_2863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.35825 17.1108H12.8629C13.649 17.1108 14.2885 16.4713 14.2885 15.6851V5.64195H10.9619C10.1758 5.64195 9.53624 5.00242 9.53624 4.21626V0.889648H3.35825C2.57209 0.889648 1.93256 1.52918 1.93256 2.31534V15.6851C1.93256 16.4713 2.57209 17.1108 3.35825 17.1108ZM5.25917 7.57455H10.9619C11.2246 7.57455 11.4372 7.78711 11.4372 8.04978C11.4372 8.31246 11.2246 8.52501 10.9619 8.52501H5.25917C4.99649 8.52501 4.78394 8.31246 4.78394 8.04978C4.78394 7.78711 4.99649 7.57455 5.25917 7.57455ZM5.25917 9.47547H10.9619C11.2246 9.47547 11.4372 9.68803 11.4372 9.9507C11.4372 10.2134 11.2246 10.4259 10.9619 10.4259H5.25917C4.99649 10.4259 4.78394 10.2134 4.78394 9.9507C4.78394 9.68803 4.99649 9.47547 5.25917 9.47547ZM5.25917 11.3764H10.9619C11.2246 11.3764 11.4372 11.589 11.4372 11.8516C11.4372 12.1143 11.2246 12.3269 10.9619 12.3269H5.25917C4.99649 12.3269 4.78394 12.1143 4.78394 11.8516C4.78394 11.589 4.99649 11.3764 5.25917 11.3764ZM5.25917 13.2773H9.06101C9.32369 13.2773 9.53624 13.4899 9.53624 13.7525C9.53624 14.0152 9.32369 14.2278 9.06101 14.2278H5.25917C4.99649 14.2278 4.78394 14.0152 4.78394 13.7525C4.78394 13.4899 4.99649 13.2773 5.25917 13.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9619 4.69136H14.0101L10.4867 1.16797V4.21613C10.4867 4.47833 10.6997 4.69136 10.9619 4.69136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2212,
    height: 16.2212,
    fill: "white",
    transform: "translate(0 0.889648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsActiveIcon);
export default __webpack_public_path__ + "static/media/documents-active-icon.2e67bca75352558283694ca0d6b0510f.svg";
export { ForwardRef as ReactComponent };